/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiAddChgOrder.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-add-chg-order";

export class AutogenModelEdiAddChgOrder<RowType extends ModelRow> extends Endpoint<RowType, RowEdiAddChgOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiAddChgOrder extends ModelRow<RowEdiAddChgOrderFields> {
	constructor(values?: Partial<RowEdiAddChgOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiAddChgOrderFields {
	alt_partner_id: string;
	charge_id: string;
	company_id: string;
	id: string;
	partner_id: string;
	version: string;
}

